// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"205":"3cb13a7007e54edf","394":"685dfa1b3ab8eeaf","671":"e179383baa9bad70","978":"0763403b67f03a2a","994":"b5520a96938fc87e"}[chunkId] + ".js";
};